const graph = {};

const filesGraphVue = require.context(".", true, /.+\.vue$/);
filesGraphVue.keys().forEach((key) => {
  graph[key.replace(/(\.\/|\.js)/g, "").replace("/", "").replace(".vue", "")] = filesGraphVue(key).default;
});

export default graph;
